import { render, staticRenderFns } from "./ToggleFavorite.vue?vue&type=template&id=b1aaff74&scoped=true"
import script from "./ToggleFavorite.vue?vue&type=script&lang=js"
export * from "./ToggleFavorite.vue?vue&type=script&lang=js"
import style0 from "./ToggleFavorite.vue?vue&type=style&index=0&id=b1aaff74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aaff74",
  null
  
)

export default component.exports